import Image from 'next/image';
import PdfPreview from '@/app/components/cards/FileCard/PdfPreview';
import type { ClientDocumentWithPassportData } from '@/types/clientsApiTypes';

export const PreviewDocument = ({ document }: { document: ClientDocumentWithPassportData }) => {
  const isPdf = document.document_url?.toLowerCase().includes('.pdf');
  if (isPdf) {
    return <PdfPreview fileUrl={document.document_url ?? ''} containerWidth={40} containerHeight={40} />;
  }
  return document.document_url ? (
    <Image
      src={document.document_url ?? ''}
      alt={document.document_name ?? ''}
      className="object-cover w-full h-full max-w-[40px] max-h-[40px]"
      width={40}
      height={40}
    />
  ) : (
    <span className="text-gray-500 italic">No file</span>
  );
};